import React from "react";
import "./layout.scss";
import { Typography } from "@mui/material";
import backArrow from "../assets/backArrow.svg";
import { useNavigate } from "react-router-dom";
import { getParams } from "../utils/helpers";
import envConfig from "../config/envConfig";
import FooterAll from "./Footer";
import { pageLocale } from "../utils/locale";

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { tug_front, tug_side } = pageLocale("newreport");
  const {
    moduleId,
    isWebsite,
    staffId,
    accessToken,
    locale,
    providerId,
    adminId,
    clientId,
    seniorId,
    seniorUuid,
  } = getParams();

  const backHandler = () => {
    if (window.history.length <= 1) {
      const params = new URLSearchParams({
        ...(staffId && { staffId }),
        ...(accessToken && { accessToken }),
        ...(locale && { locale }),
        ...(providerId && { providerId }),
        ...(adminId && { adminId }),
        ...(clientId && { clientId }),
        ...(seniorId && { seniorId: seniorUuid }),
        tab: "metrics",
      });
      const dashUrl = envConfig.DASHBOARD_URL;
      const path = "person-dashboard?" + params.toString();
      window.location.href = dashUrl + path;
      return;
    }
    navigate(-1);
  };

  const titleHandler = () => {
    if (moduleId === "4") {
      return tug_front;
    }
    if (moduleId === "1") {
      return tug_side;
    }
  };

  return (
    <div className="main-summary-wrapper">
      <div className="summary-layout-wrapper">
        {isWebsite && (
          <div className="summary-layout-header">
            <img
              src={backArrow}
              alt="backarrow"
              onClick={() => backHandler()}
            />
            <Typography>{titleHandler()}</Typography>
          </div>
        )}
        <div className="report-content-wrapper"> {children}</div>
        <FooterAll />
      </div>
    </div>
  );
};

export default Layout;
